
import { FandfFormOfPayment } from 'app/calcs/customers/fandf/interfaces'
import { IOFormOfPayment } from 'app/calcs/customers/IO/interfaces'
import { Local145FormOfPayment } from 'app/calcs/customers/local145/interfaces'
import { Local697FormOfPayment } from 'app/calcs/customers/local697/interfaces'
import { Local701FormOfPayment } from 'app/calcs/customers/local701/interfaces'
import { Local705FormOfPayment } from 'app/calcs/customers/local705/interfaces'
import { NEBFFormOfPayment } from 'app/calcs/customers/NEBF/interfaces'
import { SpousalIncomeType } from 'app/calcs/pensions/spousal/interfaces'
import * as moment from 'moment'

type SimplePensionFormOfPaymentKinds = 'singleLifeOnly' | 'FiftyPercentJointAndSurvivor' | 'seventyFivePercentJointAndSurvivor' | 'fullJointAndSurvivor'
enum SimplePensionFormOfPayment {
  singleLifeOnly,
  FiftyPercentJointAndSurvivor,
  seventyFivePercentJointAndSurvivor,
  fullJointAndSurvivor
}

const AllSimplePensionFormsOfPayment: SimplePensionFormOfPayment[] = [
  SimplePensionFormOfPayment.singleLifeOnly,
  SimplePensionFormOfPayment.FiftyPercentJointAndSurvivor,
  SimplePensionFormOfPayment.seventyFivePercentJointAndSurvivor,
  SimplePensionFormOfPayment.fullJointAndSurvivor
]

type AllFormsOfPayment = SimplePensionFormOfPayment
  | Local705FormOfPayment
  | Local701FormOfPayment
  | Local697FormOfPayment
  | IOFormOfPayment
  | NEBFFormOfPayment
  | FandfFormOfPayment
  | Local145FormOfPayment

interface ICommonPensionInputs {
  beginPaymentsAge: moment.Duration
}

interface IMonthlyPensionPayments {
  amount: number
  kind: AllFormsOfPayment | SpousalIncomeType
  beginPaymentsAge: moment.Duration
  totalLumpSum: number
  totalVestingService: number
  totalPensionCredits: number
}

interface IFormOfPaymentOption {
  label: string
  value: AllFormsOfPayment
  policyHolderFactor: number
  survivorFactor: number
  tooltip: string
  needsSpouse: boolean
}

export {
  AllFormsOfPayment,
  AllSimplePensionFormsOfPayment,
  ICommonPensionInputs,
  IMonthlyPensionPayments,
  IFormOfPaymentOption,
  SimplePensionFormOfPayment,
  SimplePensionFormOfPaymentKinds
}



// WEBPACK FOOTER //
// ./src/app/calcs/pensions/interfaces/index.ts